/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import { formatDisplayDate } from '@/util/MomentUtils';

import GetOrderPackage from '../services/GetOrderPackage';
import CalculateOrderPackageDeviceCount from '../services/CalculateOrderPackageDeviceCount';
import CalculateOrderPackagePOPDate from '../services/CalculateOrderPackagePOPDate';
import GetCommandsByOrderPackage from '../services/GetCommandsByOrderPackage';
import OrderPackageInformationForm from '../forms/OrderPackageInformationForm';
export default async function loadOrderPackageInformationForm({ orderPackageID, editable }) {
  const [orderPackage, deviceCount, commands] = await Promise.all([
    GetOrderPackage(orderPackageID),
    CalculateOrderPackageDeviceCount(orderPackageID),
    GetCommandsByOrderPackage(orderPackageID)
  ]);
  orderPackage.deviceCount = deviceCount;
 
 if (orderPackage.popDateUpdatedBy === null && orderPackage.formName !== 'Relocation Form') {
    const popDate = await CalculateOrderPackagePOPDate(orderPackageID);
    orderPackage.popDate = formatDisplayDate(popDate);
  } 
  else if (orderPackage.formName !== 'Relocation Form'){
    orderPackage.popDate = formatDisplayDate(orderPackage.popDate);
  }
  orderPackage.commands = commands;

  return new OrderPackageInformationForm({
    orderPackageID,
    editable,
    model: new Backbone.Model({
      orderPackage
    })
  });
}
